export default __webpack_public_path__ + "static/media/relay-colored.077443a2.webp";